module.exports = __webpack_public_path__ + "img/bread-account-center-fidelity.b0f4461d.png";